import { useNavigate } from 'react-router'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { LINK_KEYWORDS_HELP_GUIDE } from 'shared/constants/links'
import { KeywordsRoutes } from 'entities/ExportRouters'

type IKeywordsHelpGuideButtonProps = {
  className?: string
}

export const KeywordNewButton = observer(() => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(`/${KeywordsRoutes.root}/${KeywordsRoutes.create}`)
  }

  return (
    <Button text='New keyword' iconProps={{ icon: 'add' }} size='medium' onClick={handleClick} />
  )
})

export const KeywordsHelpGuideButton = ({ className }: IKeywordsHelpGuideButtonProps) => (
  <Button
    tag='a'
    text='Help guide'
    size='medium'
    contained='tertiary'
    className={className}
    style={{ textDecoration: 'none' }}
    href={LINK_KEYWORDS_HELP_GUIDE}
    target='_blank'
    rel='noreferrer'
    iconProps={{ icon: 'info' }}
  />
)
